module.exports = __webpack_public_path__ + "img/16.8c7cf2f6.jpg";